import { Observable } from 'rxjs/index';
import { BaseHttpService } from '../../http/base-http.service';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { UserUpdateRequest } from './user-update-request';
import { CreateUserRequest } from '@core/models/user/create-user-request';

/**
 * User API
 */
@Injectable({ providedIn: 'root' })
export class UserDataService extends BaseHttpService {

    private urls = {
        getUsers: '/user/findAll',
        getUser: '/user?include=companies',
        getUserAndSkills: '/user?include=skills,companies',
        getUserPermissions: '/connections/:user_id/acl',
        getUserById: '/users/:user_id?include=skills,companies',
        getUserByActivation:
            '/activation/:activation_code?client_id=:client_id&client_secret=:client_secret',
        resendUserActivationEmail: '/users/:user_id/resend_activation/email',
        resendUserActivationSms: '/users/:user_id/resend_activation/sms',
        users: '/users',
        notificationSettings: '/users/:user_id/notification_settings',
        user: '/users/:user_id',
        userEmail: '/users/:user_id/email',
        userPassword: '/users/:user_id/password',
        userPhone: '/users/:user_id/phone',
        createEvent: '/users/:user_id/events',
        deleteEvent: '/users/:user_id/events/:event_id',
        updateEvent: '/users/:user_id/events/:event_id',
        updateUserPositions: '/users/:user_id/skills',
        deleteUserPositions: '/users/:user_id/skills',
        availableUsersForShift:
            '/users?avail_start_at=:avail_start_at&avail_end_at=:avail_end_at&skill_set_id=:skill_set_id&schedule_id=:scheduleId',
        email: '/email/:token',
        ihdUsers: '/ihd/locations/:location_id/users',
        ihdNewUser: '/ihd/users',
        ihdUser: '/ihd/locations/:location_id/users/:user_id',
        ihdDrivers: '/ihd/locations/:location_id/drivers',
        ihdNewDriver: '/ihd/drivers',
        ihdDeleteDriver: '/ihd/locations/:location_id/drivers/:user_id'
    };

    protected override initApiEndpoint() {
        this.apiEndpoint = environment.api.endpointV2;
    }

    fetchUser(): Observable<any> {
        return this.get(this.urls.getUser);
    }

    fetchUserPermissions(userId: string): Observable<any> {
        let requestUrl: string = this.urls.getUserPermissions.replace(
            ':user_id',
            userId
        );
        return this.get(requestUrl);
    }

    // updateUserPositions(
    //     userId: string,
    //     request: UserPositionsUpdateRequest
    // ): Observable<any> {
    //     let requestURL: string = this.urls.updateUserPositions.replace(
    //         ':user_id',
    //         userId
    //     );
    //     return this.post(requestURL, request);
    // }

    // deleteUserPositions(
    //     userId: string,
    //     request: UserPositionsUpdateRequest
    // ): Observable<any> {
    //     let requestURL: string = this.urls.deleteUserPositions.replace(
    //         ':user_id',
    //         userId
    //     );
    //     return this.delete(requestURL, request);
    // }

    // createUser(request: UserRequest) {
    //     const requestUrl: string = environment.api.endpointV3 + this.urls.users;
    //     return this.post(requestUrl, request, undefined, true);
    // }

    updateUser(userId: string, request: UserUpdateRequest) {
        let requestURL: string = this.urls.user.replace(':user_id', userId);
        return this.put(requestURL, request);
    }

    updateUserPhone(userId: string, phone: string, pin: string) {
        const request: any = { phone, brand: 'ihd' };
        if (pin) {
            request.pin = pin;
        }
        let requestURL: string = this.urls.userPhone.replace(
            ':user_id',
            userId
        );
        return this.put(requestURL, request);
    }

    updateUserEmail(userId: string, email: string, pin: string) {
        const request: any = { email, brand: 'ihd' };
        if (pin) {
            request.pin = pin;
        }
        let requestURL: string = this.urls.userEmail.replace(
            ':user_id',
            userId
        );
        return this.put(requestURL, request);
    }

    updateUserPassword(
        userId: string,
        oldPassword: string,
        newPassword: string
    ) {
        const request: any = {
            password: oldPassword,
            new_password: newPassword,
        };
        let requestURL: string = this.urls.userPassword.replace(
            ':user_id',
            userId
        );
        return this.put(requestURL, request);
    }

    fetchIHDUsers(locationId: string) {
        const url: string  = environment.api.endpointBase + this.urls.ihdUsers.replace(':location_id', locationId);
        return this.get(url, undefined, true);
    }

    createIHDUser(request: CreateUserRequest): Observable<any> {
        const url: string  = environment.api.endpointBase + this.urls.ihdNewUser;
        return this.post(url, request, undefined, true);
    }

    deleteIHDUser(userId: string, locationId: string): Observable<any> {
        const url: string  = environment.api.endpointBase + this.urls.ihdUser.replace(':user_id', userId).replace(':location_id', locationId);
        return this.delete(url, null, undefined, true);
    }

    resendInvitation(userId: string): Observable<any> {
        const url: string  = environment.api.endpointV2 + this.urls.resendUserActivationSms.replace(':user_id', userId);
        return this.post(url, null, undefined, true);
    }

    fetchIHDDrivers(locationId: string) {
        const url: string  = environment.api.endpointBase + this.urls.ihdDrivers.replace(':location_id', locationId);
        return this.get(url, undefined, true);
    }

    createIHDDriver(request: CreateUserRequest): Observable<any> {
        const url: string  = environment.api.endpointBase + this.urls.ihdNewDriver;
        return this.post(url, request, undefined, true);
    }

    deleteIHDDriver(userId: string, locationId: string): Observable<any> {
        const url: string  = environment.api.endpointBase + this.urls.ihdDeleteDriver.replace(':user_id', userId).replace(':location_id', locationId);
        return this.delete(url, null, undefined, true);
    }
}
